<template>
    <Icon name="image">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M21 17.444C21 18.3 20.1 19 19 19H5c-1.1 0-2-.7-2-1.556V6.556C3 5.7 3.9 5 5 5h14c1.1 0 2 .7 2 1.556v10.888zm-9.437-3.919a.5.5 0 0 1-.862.013l-1.26-2.065a.5.5 0 0 0-.861.012l-2.153 3.767a.5.5 0 0 0 .435.748h10.292a.5.5 0 0 0 .438-.741L14.573 9.78a.5.5 0 0 0-.872-.006l-2.138 3.75z"
                fill-rule="evenodd"
            ></path>
        </svg>
    </Icon>
</template>

<script>
import Icon from './icon';
export default {
    components: {
        Icon,
    },
};
</script>

<style lang="scss" scoped>
.icon--image {
    svg {
        padding: 0;
    }
}
</style>
